import { configureStore } from '@reduxjs/toolkit';
import { cartApi } from '../services/cartApi';
import { favoriteApi } from '../services/favoriteApi';
import { userApi } from '../services/userApi';
import { paymentApi } from '../services/paymentApi';
import { blogApi } from '../services/blogApi';

export const store = configureStore({
  reducer: {
    [cartApi.reducerPath]: cartApi.reducer,
    [favoriteApi.reducerPath]: favoriteApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      cartApi.middleware,
      favoriteApi.middleware,
      userApi.middleware,
      paymentApi.middleware,
      blogApi.middleware,
    ]),
}); 